import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class InfoDialogComponent  {
  public infoMessage: string='';
  public title: string = 'Info';
  public infoButtonText: string = 'Ok';



  /**
   * Constructor
   *
   * @param {MatDialogRef<InfoDialogComponent>} dialogRef
   */
 constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<InfoDialogComponent>,
        private _translateService: TranslateService,

    ) {
        if (data) {
            this._translateService.get(data.infoMessage, data.interpolateParams).subscribe(msg => this.infoMessage = msg);

            this._translateService.get(data.title).subscribe(msg => this.title = msg);

            this._translateService.get(data.infoButtonText).subscribe(msg => this.infoButtonText = msg);
        }
    }

}



